import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findUser = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup?`+params,
        method: 'GET'
    })
}
// 单个新增结算账号
export const addTask = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup`,
        method: 'POST',
        data: data
    })
}
// 查询代理商
export const findAgent = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?`+params,
        method: 'GET'
    })
}
// /joins-sales-cloud/v1/accountGroup编辑分组
export const editAcct = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup`,
        method: 'PUT',
        data: data
    })
}
//删除任务
export const delTask = (params) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/guo_xin/task/`+params,
        method: 'DELETE'
    })
}

// 查询分组明细
export const getGroupDetails = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details?`+params,
        method: 'GET'
    })
}

// 新增分组明细
export const addGroupDetail = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details`,
        method: 'POST',
        data: data
    })
}

// 删除分组明细
export const deleteGroupDetails = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details/${ids}`,
        method: 'DELETE'
    })
}

// 删除分组
export const deleteAccountGroup = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/${ids}`,
        method: 'DELETE'
    })
}

// 转移分组明细
export const transferGroupDetail = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details`,
        method: 'PUT',
        data: data
    })
}
// 启用/禁用账户
export const openEnable = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/openEnable`,
        method: 'PUT',
        data: data
    })
}

// 冻结钱包
export const freezeWallet = (userId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details/freezeWallet?userId=${userId}`,
        method: 'PUT'
    })
}

// 解冻钱包
export const unfreezeWallet = (userId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details/unfreezeWallet?userId=${userId}`,
        method: 'PUT'
    })
}

/* ============== 动态增项配置 ============== */
// 增项列表
export const findExtraItem = (groupId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/extraItem?groupId=${groupId}`,
        method: 'GET'
    })
}
// 新增增项
export const addExtraItem = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/extraItem`,
        method: 'POST',
        data: data
    })
}
// 编辑增项
export const updateExtraItem = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/extraItem`,
        method: 'PUT',
        data: data
    })
}
// 删除增项
export const deleteExtraItem = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/extraItem/${ids}`,
        method: 'DELETE'
    })
}

/* ============== 工程师-子阶段关联管理 ============== */
// 查询可选子阶段列表（按父商品分组）
export const findGoodsChildren = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/children?` + params,
        method: 'GET'
    })
}

// 设置单个工程师关联的子阶段（覆盖式）
export const saveEngineerGoods = (userId, goodsIds) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/engineer/goods/${userId}`,
        method: 'PUT',
        data: { goodsIds: goodsIds || [] }
    })
}

// 批量设置多个工程师关联的子阶段（覆盖式）
export const batchSaveEngineerGoods = (groupId, userIds, goodsIds) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/batch_goods/${groupId}`,
        method: 'PUT',
        data: { userIds: userIds || [], goodsIds: goodsIds || [] }
    })
}